var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState, useEffect, useMemo, createRef, useRef } from 'react';
import clsx from 'clsx';
import * as Yup from 'yup';
import AddressLookup from '../AddressLookup/AddressLookup';
import Button from '../Button/Button';
import RoundButton from '../RoundButton/RoundButton';
import TextField from '../TextField/TextField';
import { Form, Formik, FormikContext } from 'formik';
import { addressFields, errorMessages, getCountryFromAlpha2Code, replaceCountryCodes, inputValidationRegex, SiteContext, addressBookFields, phoneValidation, trimPhoneSpace, getCoordinates, isIpad, } from '../../utils/common';
import useStyles from '../ProductDetailPurchase/ProductDetailPurchase.styles';
import useMissingContactInfoStyles from '../MissingContactInfoFields/MissingContactInfoFields.styles';
import formatDate from 'date-fns/format';
import addMonths from 'date-fns/addMonths';
import differenceInMonths from 'date-fns/differenceInMonths';
import CheckCircle from '../CheckCircle/CheckCircle';
import SavedAddressesLogin from '../SavedAdressesLogin/SavedAddressesLogin';
import Modal from '../Modal/Modal';
import SignInModal from '../SignInModal/SignInModal';
import { useTheme, Box } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import ProductPageAddressBook from '../ProductPageAddressBook/ProductPageAddressBook';
import Icon from '../Icon/Icon';
import SavedAddressesEmpty from '../SavedAddressesEmpty/SavedAddressesEmpty';
import ProductCountriesList from '../ProductCountriesList/ProductCountriesList';
import Link from '../Link/Link';
import MissingContactInfoFields, { initialValues as missingContactInfoInitialValues, validationSchema as missingContactInfoValidationConfig, } from '../MissingContactInfoFields/MissingContactInfoFields';
import GiftUnavailableModal from '../GiftUnavailableModal/GiftUnavailableModal';
import { useSessionStorage } from '../../utils/utilityCustomHooks';
import axios from 'axios';
export const validationConfig = Yup.object().shape({
    firstName: Yup.string()
        .trim()
        .min(1, errorMessages(1).minChars)
        .max(50, errorMessages(50).maxChars)
        .required('Please enter a first name')
        .matches(inputValidationRegex, errorMessages().unsupportedCharacters),
    lastName: Yup.string()
        .trim()
        .min(1, errorMessages(1).minChars)
        .max(40, errorMessages(40).maxChars)
        .required('Please enter a last name')
        .matches(inputValidationRegex, errorMessages().unsupportedCharacters),
    isChooseAddress: Yup.boolean(),
    shouldValidatePhone: Yup.boolean(),
    phone: Yup.string()
        .trim()
        .when(['isChooseAddress', 'shouldValidatePhone'], {
        is: (isChooseAddress, shouldValidatePhone) => !!isChooseAddress && !!shouldValidatePhone,
        then: Yup.string()
            .required(errorMessages().required)
            .max(50, errorMessages(50).maxChars)
            .when('isLoggedIn', {
            is: (isLoggedIn) => !!isLoggedIn,
            then: Yup.string()
                .matches(/^[+]?[0-9 ]*$/, errorMessages().phone)
                .min(4, errorMessages(4).minChars),
            otherwise: Yup.string()
                .test('Phone Number Validation', errorMessages().phone, (value) => phoneValidation(value))
                .min(9, errorMessages(9).minChars),
        }),
    }),
    recipientAddress: Yup.string()
        .min(3, errorMessages(4).minChars)
        .when('isChooseAddress', {
        is: (isChooseAddress) => isChooseAddress,
        then: Yup.string().required(errorMessages().required),
    })
        .oneOf([Yup.ref('originalAddressSelection'), null], "Please select an address from the list or choose 'enter manually'"),
    addressLine1: Yup.string()
        .required('Please enter address line 1')
        .matches(inputValidationRegex, errorMessages().unsupportedCharacters),
    addressLine2: Yup.string().matches(inputValidationRegex, errorMessages().unsupportedCharacters),
    city: Yup.string()
        .required('Please enter a city')
        .matches(inputValidationRegex, errorMessages().unsupportedCharacters),
    county: Yup.string().when('isManualAddress', {
        is: true,
        then: Yup.string()
            .required('Please enter a county')
            .matches(inputValidationRegex, errorMessages().unsupportedCharacters),
    }),
    postalCode: Yup.string()
        .when('shouldValidatePostCode', {
        is: (shouldValidatePostCode) => shouldValidatePostCode,
        then: Yup.string().required('Please enter a postcode'),
    })
        .matches(inputValidationRegex, errorMessages().unsupportedCharacters),
    country: Yup.string().required('Please select a country'),
    isManualAddress: Yup.boolean(),
    isLoggedIn: Yup.boolean(),
});
export const initialValues = {
    firstName: '',
    lastName: '',
    recipientAddress: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    county: '',
    postalCode: '',
    country: '',
    phone: '',
    isManualAddress: false,
    isCalendarPicked: false,
    shouldValidatePostCode: true,
    deliveryDate: '',
    selectedDeliveryOptionIndex: 0,
    productAvailability: [],
    addressId: '',
    isLoggedIn: false,
    oldCalendar: false,
};
const PurchaseRecipient = ({ step, currentStep, setCurrentStep, sameDay, formatAddressCallback, handleCancelChanges, variant, initialRecipientAddress, selectedServiceDescription, deliveryDate, productAvailabilityCallback, countryCode, isUpdateRecipient, addNewAddress, updateContactAddress, newAddressId, onSignIn, isAddNewAddress, setIsAddNewAddress, isUpdateDate, initialRecipientAddressId, isDropship, isInternational, countriesList, isFuneral, isVariantChange, setIsVariantChange, hasVariants, isFromBasket, isFromBasketUpdate, updateMissingContactAddress, sendStepAnalytics, hasMissingAddrField, setHasMissingAddrField, isFromTributeUpdate, oldCalendar, saveUserJourneyAnalytics, locationInternationalDelivery, hasClickAndCollectDeliveryType, setCoordinates, isAddNewButtonClicked, setIsAddNewButtonClicked, trackEnterManualAddressClick, }) => {
    var _a;
    const { isFlyingFlowers, shorthand, getCustomer } = useContext(SiteContext);
    const customer = (_a = getCustomer === null || getCustomer === void 0 ? void 0 : getCustomer.data) === null || _a === void 0 ? void 0 : _a.customer;
    const savedAddresses = customer === null || customer === void 0 ? void 0 : customer.shippingAddresses;
    const { classes } = useStyles();
    const { classes: classesMissingContactInfo } = useMissingContactInfoStyles();
    const formikContext = useContext(FormikContext);
    const { deliveryOptions, productAvailability, deliveryDate: formikDeliveryDate, addressId: formikAddressId, showManualAddress, funeralServiceDate, } = formikContext.values;
    const getClickLocation = () => {
        if (isUpdateRecipient) {
            return 'Cart';
        }
        if (isInternational) {
            return 'International PDP';
        }
        return 'Domestic PDP';
    };
    const setManualAddressChosen = (isManualAddress) => {
        !!formikContext && formikContext.setFieldValue('isManualAddress', isManualAddress);
        if (isManualAddress) {
            const clickLocation = getClickLocation();
            trackEnterManualAddressClick && trackEnterManualAddressClick(clickLocation);
        }
    };
    const [isSaveToAddressBook, setSaveToAddressBook] = useState(true);
    const [openSignInModal, setSignInModal] = useState(false);
    const [disableButton, setDisableButton] = useState(false);
    const theme = useTheme();
    const isMobile = !useMediaQuery({ query: `(min-width: ${theme.breakpoints.values.sm}px)` });
    const [openInternationalModal, setOpenInternationalModal] = useState(false);
    const [isChangeAddress, setIsChangeAddress] = useState(false);
    const [addressBookId, setAddressBookId] = useState(newAddressId || '');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isUnavailableModalOpen, setUnavailableModalOpen] = useState(false);
    const { getFromSessionStorage, removeFromSessionStorage } = useSessionStorage();
    const [onEditClick, setOnEditClick] = useState(false);
    const [isMissingAddressLine1, setIsMissingAddressLine1] = useState(false);
    const [isMissingPhoneNumber, setIsMissingPhoneNumber] = useState(false);
    const [isUpdateBasketOnLoad, setIsUpdateBasketOnLoad] = useState(isFromBasket);
    const stepRef = createRef();
    const prevStepRef = useRef();
    const isTabletAndBelow = useMediaQuery({ query: `(max-width: ${theme.breakpoints.values.md}px)` });
    const addressAvailable = savedAddresses === null || savedAddresses === void 0 ? void 0 : savedAddresses.filter((address) => !!address.addressLine1 && !!address.firstName && !!countryCode && countryCode === address.country).sort((a, b) => {
        return a.isDefaultAddress === true ? -1 : b.isDefaultAddress === true ? 1 : 0;
    });
    const defaultAddress = useMemo(() => {
        return !!initialRecipientAddressId
            ? addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.find((address) => (address === null || address === void 0 ? void 0 : address.id) === initialRecipientAddressId)
            : addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.find((address) => !!address.isDefaultAddress);
    }, [addressAvailable, initialRecipientAddressId]);
    useEffect(() => {
        if (newAddressId && formikContext) {
            formikContext.setFieldValue('addressId', newAddressId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newAddressId]);
    useEffect(() => {
        var _a;
        if (prevStepRef.current === currentStep + 1 && // Navigating back from the next step
            currentStep === step // Current step matches
        ) {
            if (isTabletAndBelow) {
                const headerOffset = isIpad() ? 120 : 90;
                const offsetTop = stepRef.current ? stepRef.current.offsetTop - headerOffset : 0;
                if (offsetTop)
                    window.scrollTo({ top: offsetTop });
            }
            else {
                (_a = stepRef === null || stepRef === void 0 ? void 0 : stepRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'start', inline: 'start', behavior: 'smooth' });
            }
        }
        prevStepRef.current = currentStep;
    }, [currentStep, step, stepRef, isTabletAndBelow]);
    useEffect(() => {
        if (!!newAddressId && (isAddNewAddress || (addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) === 1 || (addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) === 0)) {
            setAddressBookId(newAddressId);
            const address = addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.find((address) => address.id === newAddressId);
            !!address &&
                (addressBookFields === null || addressBookFields === void 0 ? void 0 : addressBookFields.map((addressLine) => {
                    const addressValue = address[addressLine];
                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue(addressLine, addressValue !== null && addressValue !== void 0 ? addressValue : '');
                }));
            isFlyingFlowers && (formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('phone', ''));
            setIsAddNewAddress && setIsAddNewAddress(true);
            handleSaveManualAddressCallback(address === null || address === void 0 ? void 0 : address.city, address === null || address === void 0 ? void 0 : address.county, address === null || address === void 0 ? void 0 : address.postalCode, address === null || address === void 0 ? void 0 : address.addressLine2);
        }
        else if (!addressBookId && formikAddressId)
            setAddressBookId(formikAddressId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newAddressId, formikAddressId]);
    useEffect(() => {
        if (!!formikContext) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('isChooseAddress', (!!(customer === null || customer === void 0 ? void 0 : customer.id) && !addressAvailable) ||
                (!!(customer === null || customer === void 0 ? void 0 : customer.id) && isAddNewAddress) ||
                (!!(customer === null || customer === void 0 ? void 0 : customer.id) && !(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length)) ||
                !(customer === null || customer === void 0 ? void 0 : customer.id));
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('shouldValidatePhone', !!isFlyingFlowers ? false : true);
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('shouldValidatePostCode', isInternationalAddress
                ? false
                : !(customer === null || customer === void 0 ? void 0 : customer.id) || isAddNewAddress || (!!(customer === null || customer === void 0 ? void 0 : customer.id) && !(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length)));
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('isLoggedIn', !!(customer === null || customer === void 0 ? void 0 : customer.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer === null || customer === void 0 ? void 0 : customer.id, isAddNewAddress, addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length, isFlyingFlowers]);
    /** submitting errors to Analytics */
    useEffect(() => {
        var _a;
        if (sendStepAnalytics &&
            !!((_a = Object.keys(formikContext === null || formikContext === void 0 ? void 0 : formikContext.errors)) === null || _a === void 0 ? void 0 : _a.length) &&
            currentStep === step &&
            isSubmitted &&
            (!isFromBasket || !isFromBasketUpdate)) {
            sendStepAnalytics('ADDRESS', formikContext === null || formikContext === void 0 ? void 0 : formikContext.values, formikContext === null || formikContext === void 0 ? void 0 : formikContext.errors);
            setIsSubmitted(false);
        }
    }, [
        currentStep,
        formikContext === null || formikContext === void 0 ? void 0 : formikContext.errors,
        formikContext === null || formikContext === void 0 ? void 0 : formikContext.values,
        isFromBasket,
        isFromBasketUpdate,
        isSubmitted,
        sendStepAnalytics,
        step,
    ]);
    useEffect(() => {
        if (currentStep === step) {
            const buyAgainSessionStorageValues = getFromSessionStorage('buyAgainOrderItem');
            if (buyAgainSessionStorageValues) {
                removeFromSessionStorage('buyAgainOrderItem');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep, step]);
    const checkForMissingAddrFields = () => {
        const selectedAddress = savedAddresses === null || savedAddresses === void 0 ? void 0 : savedAddresses.find((addr) => addr.id === addressBookId);
        const hasMissingAddrField = !!selectedAddress &&
            !isAddNewAddress &&
            !isFlyingFlowers &&
            !isFromBasket &&
            !isFromBasketUpdate &&
            !(selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.phone);
        if (hasMissingAddrField) {
            setHasMissingAddrField && setHasMissingAddrField(true);
        }
        return hasMissingAddrField;
    };
    const isInternationalAddress = isInternational || (shorthand === 'uk' && countryCode === 'IE') || (shorthand === 'ie' && countryCode === 'GB');
    const displayInternationLink = !isInternationalAddress && !isFlyingFlowers && !isFuneral && !!(countriesList === null || countriesList === void 0 ? void 0 : countriesList.length);
    const setDeliveryDates = (availability) => {
        formikContext.setFieldValue('productAvailability', availability);
        const defaultToCalendarPicked = (!!initialRecipientAddress && !!formikDeliveryDate) || (addressBookId && !!formikDeliveryDate);
        formikContext.setFieldValue('isCalendarPicked', defaultToCalendarPicked);
        if (isInternational || oldCalendar) {
            const firstItem = availability[0];
            const date = defaultToCalendarPicked ? formikDeliveryDate || (firstItem === null || firstItem === void 0 ? void 0 : firstItem.date) : firstItem === null || firstItem === void 0 ? void 0 : firstItem.date;
            formikContext.setFieldValue('deliveryDate', date);
        }
    };
    const handleAddressFormatCall = (suggestion, format) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        setUnavailableModalOpen(false);
        setDisableButton(false);
        const response = yield formatAddressCallback({
            suggestion,
            format,
            variant,
            countryCode,
            endDate: differenceInMonths(new Date(formikDeliveryDate), new Date()) >= 2
                ? formatDate(addMonths(new Date(formikDeliveryDate), 2), 'yyyy-MM-dd')
                : undefined,
            tributeDate: funeralServiceDate,
        });
        if (!response || response.error) {
            throw new Error(`Address formatting returned an error response: ${response === null || response === void 0 ? void 0 : response.error}`);
        }
        else if (!response.data) {
            throw new Error('No results returned from address formatting');
        }
        const { address, availability } = response.data.formattedAddressAndProductAvailability;
        const updateBasketOnLoadCheck = !!isUpdateBasketOnLoad && ((_b = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _b === void 0 ? void 0 : _b.addressLine1) === '-';
        const missingAddressLine1check = !address.addressLine1 && !updateBasketOnLoadCheck;
        setIsMissingAddressLine1(missingAddressLine1check);
        if (missingAddressLine1check) {
            setHasMissingAddrField && setHasMissingAddrField(true);
            setDeliveryDates(availability);
            return address;
        }
        else if (!availability.length && (isInternational || oldCalendar)) {
            setUnavailableModalOpen(true);
            setDisableButton(true);
        }
        isUpdateBasketOnLoad && setIsUpdateBasketOnLoad(false);
        setDeliveryDates(availability);
        return Object.assign(Object.assign({}, address), { addressLine1: updateBasketOnLoadCheck ? '-' : address.addressLine1 });
    });
    const handleSaveManualAddressCallback = (city, county, postalCode, addressLine2) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        setDisableButton(false);
        const today = new Date();
        const startDate = formatDate(today, 'yyyy-MM-dd');
        const endDate = isFromTributeUpdate && funeralServiceDate
            ? formatDate(addMonths(new Date(funeralServiceDate), 2), 'yyyy-MM-dd')
            : formatDate(addMonths(today, 2), 'yyyy-MM-dd');
        const response = yield productAvailabilityCallback({
            startDate,
            endDate,
            variant,
            address: {
                city: city || formikContext.values.city,
                county: county || formikContext.values.county,
                postalCode: postalCode || formikContext.values.postalCode,
                country: formikContext.values.country,
                addressLine2: addressLine2 !== null && addressLine2 !== void 0 ? addressLine2 : formikContext.values.addressLine2,
            },
        });
        if (!response || response.error) {
            throw new Error(`The product availability check returned an error response: ${response === null || response === void 0 ? void 0 : response.error}`);
        }
        const { productAvailability } = (_c = response === null || response === void 0 ? void 0 : response.data) !== null && _c !== void 0 ? _c : {};
        if (!(productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.length) && (isInternational || oldCalendar)) {
            setUnavailableModalOpen(true);
            setDisableButton(true);
            formikContext.setFieldValue('recipientAddress', '');
        }
        else {
            setDisableButton(false);
        }
        setDeliveryDates(productAvailability);
    });
    const changeAddress = () => {
        setUnavailableModalOpen(false);
        formikContext.setFieldValue('addressId', '');
    };
    const validDeliveryDate = productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.some((availableDate) => (availableDate === null || availableDate === void 0 ? void 0 : availableDate.date) === deliveryDate);
    const validDeliveryOption = deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.some((deliveryOption) => deliveryOption.title === selectedServiceDescription);
    const validDelivery = initialRecipientAddress && validDeliveryDate && validDeliveryOption;
    const handleSubmit = (skipMissingAddrCheck) => __awaiter(void 0, void 0, void 0, function* () {
        const isSkip = typeof skipMissingAddrCheck === 'object' ? false : skipMissingAddrCheck;
        if ((customer === null || customer === void 0 ? void 0 : customer.id) && !isFuneral && !isSkip) {
            const hasMissingAddrField = checkForMissingAddrFields();
            if (hasMissingAddrField) {
                setIsMissingPhoneNumber(true);
                return false;
            }
        }
        if (isMissingAddressLine1) {
            setHasMissingAddrField && setHasMissingAddrField(true);
            return false;
        }
        if (validDelivery && isUpdateRecipient) {
            formikContext.setFieldValue('deliveryOptionConfirmed', true);
        }
        const { firstName, lastName, addressLine1, addressLine2, city, county, postalCode, country, phone, deliveryInstructionNote, deliveryInstructionOption, recipientAddress, } = formikContext.values;
        const isFromPCC = !isFromBasket && initialRecipientAddress && recipientAddress !== '';
        if ((customer === null || customer === void 0 ? void 0 : customer.id) &&
            isSaveToAddressBook &&
            (!!isAddNewAddress || (addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) === 0) &&
            (isFromBasket || !initialRecipientAddress || isFromPCC) &&
            addNewAddress &&
            !newAddressId &&
            !!formikContext.isValid &&
            !!formikContext.dirty &&
            !!addressLine1) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryInstructionsNote', '');
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryInstructionOption', '');
            yield addNewAddress({
                firstName,
                lastName,
                addressLine1,
                addressLine2,
                city,
                county,
                postalCode,
                country,
                phone,
                deliveryInstructionNote: isDropship ? '' : deliveryInstructionNote,
                deliveryInstructionOption: isDropship ? '' : deliveryInstructionOption,
            });
        }
        else if ((customer === null || customer === void 0 ? void 0 : customer.id) &&
            !!isSaveToAddressBook &&
            (!!isAddNewAddress || (addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) === 0) &&
            (isFromBasket || !initialRecipientAddress || isFromPCC) &&
            addNewAddress &&
            newAddressId &&
            updateContactAddress &&
            !!formikContext.isValid &&
            !!formikContext.dirty &&
            !!addressLine1) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryInstructionsNote', '');
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryInstructionOption', '');
            yield updateContactAddress({
                firstName,
                lastName,
                addressLine1,
                addressLine2,
                city,
                county,
                postalCode,
                country,
                phone,
                deliveryInstructionNote: isDropship ? '' : deliveryInstructionNote,
                deliveryInstructionOption: isDropship ? '' : deliveryInstructionOption,
            });
        }
        setOnEditClick(false);
        formikContext.submitForm();
        setIsSubmitted(true);
    });
    const countryDetails = getCountryFromAlpha2Code(countryCode);
    const formattedAddress = replaceCountryCodes(formikContext.values);
    const signIn = (values) => __awaiter(void 0, void 0, void 0, function* () {
        if (onSignIn) {
            yield onSignIn(values);
            setSignInModal(false);
        }
    });
    const handelNewAddress = () => {
        isDropship && (formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryInstructionsNote', ''));
        isDropship && (formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryInstructionOption', ''));
        !!isFlyingFlowers && (formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('phone', ''));
        setIsAddNewButtonClicked === null || setIsAddNewButtonClicked === void 0 ? void 0 : setIsAddNewButtonClicked(true);
        if (!newAddressId) {
            formikContext.setFieldValue('recipientAddress', '');
            addressBookFields === null || addressBookFields === void 0 ? void 0 : addressBookFields.map((addressLine) => formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue(addressLine, ''));
            isDropship && (formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryInstructionsNote', ''));
            isDropship && (formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryInstructionOption', ''));
        }
        formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('country', countryCode);
        setIsAddNewAddress && setIsAddNewAddress(true);
        setSaveToAddressBook(true);
        isFromBasket && formikContext.setFieldValue('addressId', '');
    };
    const isAutoFocus = !isMobile && ((!!newAddressId && currentStep === step) || (currentStep === step && isAddNewAddress));
    const autoFocus = isAutoFocus;
    const addressPlaceholder = (shorthand === 'ie' && countryCode !== 'GB') || countryCode === 'IE'
        ? 'Try the eircode or street name'
        : 'Enter delivery postcode';
    const handleSelectFromAddressBook = () => {
        setIsAddNewAddress && setIsAddNewAddress(false);
        setSaveToAddressBook(false);
        setAddressBookId(newAddressId || addressBookId || (defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.id) || '');
        formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('isChooseAddress', false);
    };
    const formikConfigMissingContactInfo = {
        initialValues: missingContactInfoInitialValues,
        validationSchema: missingContactInfoValidationConfig,
        onSubmit: (values) => updateMissingAddressField(values)
            .then((response) => {
            isMissingPhoneNumber && formikContext.setFieldValue('phone', values.updatePhone);
            if (isMissingAddressLine1) {
                formikContext.setFieldValue('addressLine1', values.updateAddressLine1);
            }
            setHasMissingAddrField && setHasMissingAddrField(false);
            isMissingAddressLine1 && setIsMissingAddressLine1(false);
            isMissingPhoneNumber && setIsMissingPhoneNumber(false);
        })
            .catch((error) => {
            //empty
        }),
    };
    const updateMissingAddressField = (values) => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        const { updatePhone, updateAddressLine1 } = values;
        const { firstName, lastName, addressLine1, addressLine2, city, county, postalCode, country, deliveryInstructionNote, deliveryInstructionOption, phone, } = formikContext.values;
        updateMissingContactAddress &&
            updateMissingContactAddress({
                id: addressBookId,
                firstName,
                lastName,
                addressLine1: isMissingAddressLine1 ? updateAddressLine1 : addressLine1,
                addressLine2,
                city,
                county,
                postalCode,
                country,
                phone: isMissingPhoneNumber ? updatePhone : phone,
                isDefaultAddress: (_d = savedAddresses === null || savedAddresses === void 0 ? void 0 : savedAddresses.find((addr) => addr.id === addressBookId)) === null || _d === void 0 ? void 0 : _d.isDefaultAddress,
                deliveryInstructionNote: isDropship ? '' : deliveryInstructionNote,
                deliveryInstructionOption: isDropship ? '' : deliveryInstructionOption,
            }).then((response) => __awaiter(void 0, void 0, void 0, function* () {
                if (isMissingPhoneNumber) {
                    yield (getCustomer === null || getCustomer === void 0 ? void 0 : getCustomer.refetch().then((res) => {
                        handleSubmit(true);
                    }));
                }
                else
                    return;
            }));
    });
    const handleEditClick = () => {
        setOnEditClick(true);
        setCurrentStep(step);
    };
    const getAddressLatLongDetails = (addressFields) => __awaiter(void 0, void 0, void 0, function* () {
        const BING_MAPS_API_KEY = process.env.NEXT_PUBLIC_BING_MAPS_KEY;
        const BING_MAPS_LOCATIONS_URL = process.env.NEXT_PUBLIC_BING_MAPS_LOCATIONS_URL || '';
        yield axios
            .get(BING_MAPS_LOCATIONS_URL, {
            params: {
                countryRegion: addressFields === null || addressFields === void 0 ? void 0 : addressFields.country,
                adminDistrict: addressFields === null || addressFields === void 0 ? void 0 : addressFields.county,
                locality: addressFields === null || addressFields === void 0 ? void 0 : addressFields.city,
                postalCode: addressFields === null || addressFields === void 0 ? void 0 : addressFields.postalCode,
                addressLine: addressFields === null || addressFields === void 0 ? void 0 : addressFields.addressLine1,
                key: BING_MAPS_API_KEY,
            },
        })
            .then((response) => {
            var _a, _b, _c, _d, _e, _f;
            const coordinates = ((_f = (_e = (_d = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.resourceSets) === null || _b === void 0 ? void 0 : _b[0].resources) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.geocodePoints) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.coordinates) || [];
            setCoordinates === null || setCoordinates === void 0 ? void 0 : setCoordinates(coordinates);
            if (isUnavailableModalOpen)
                return;
            const { latitude, longitude } = getCoordinates(coordinates);
            const { addressLine1 = '', addressLine2 = '', addressLine3 = '', city = '', county = '', country = '', postalCode = '', } = addressFields;
            formatAddressCallback({
                suggestion: '',
                format: '',
                variant,
                countryCode,
                endDate: differenceInMonths(new Date(formikDeliveryDate), new Date()) >= 2
                    ? formatDate(addMonths(new Date(formikDeliveryDate), 2), 'yyyy-MM-dd')
                    : undefined,
                address: {
                    addressLine1,
                    addressLine2,
                    addressLine3,
                    city,
                    country,
                    county,
                    postalCode,
                },
                deliveryType: 'Collection',
                latitude,
                longitude,
            }).then((availabilityResponse) => {
                var _a, _b;
                const ccAvailability = (_b = (_a = availabilityResponse === null || availabilityResponse === void 0 ? void 0 : availabilityResponse.data) === null || _a === void 0 ? void 0 : _a.formattedAddressAndProductAvailability) === null || _b === void 0 ? void 0 : _b.availability;
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('ccAvailability', ccAvailability);
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('custLatitude', latitude);
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('custLongitude', longitude);
            });
            // have to use this for collection ruleId
        })
            .catch((error) => {
            console.log(error);
        });
    });
    const stepContentWithEditIcon = currentStep > step ? (_jsx("div", { className: clsx(classes.completed, isFromTributeUpdate ? classes.tributeUpdateCompleted : ''), children: _jsxs(TextField, { name: "placeholderRecipientAddress", fullWidth: true, completed: true, onClick: handleEditClick, children: [_jsx("div", { children: `${formattedAddress.firstName} ${formattedAddress.lastName}` }), !isFlyingFlowers && _jsx("div", { children: `${formattedAddress.phone}` }), addressFields.map((addressLine) => {
                    const addressValue = formattedAddress[addressLine];
                    return !!addressValue && _jsx("div", { children: addressValue }, `${addressLine}${addressValue}`);
                })] }) })) : null;
    return (_jsxs("div", { ref: stepRef, children: [_jsx(Modal, { open: openSignInModal, setOpen: () => setSignInModal(false), fullScreen: isMobile, title: "Your Account", fullWidth: true, maxWidth: "md", children: _jsx(SignInModal, { onSignIn: signIn, saveUserJourneyAnalytics: saveUserJourneyAnalytics }) }), !!(countriesList === null || countriesList === void 0 ? void 0 : countriesList.length) && (_jsx(Modal, { open: openInternationalModal, setOpen: setOpenInternationalModal, fullScreen: isMobile, fullWidth: true, maxWidth: "md", className: classes.internationalLink, children: _jsx(ProductCountriesList, { countriesList: countriesList }) })), _jsx(Modal, { open: !!hasMissingAddrField, setOpen: () => (setHasMissingAddrField ? setHasMissingAddrField(false) : null), fullScreen: isMobile, fullWidth: true, maxWidth: "md", title: "We just need", className: classesMissingContactInfo.missingContactInfoModal, keepMounted: false, children: _jsx(Formik, Object.assign({}, formikConfigMissingContactInfo, { children: ({ isSubmitting }) => (_jsx(Form, { children: _jsx(MissingContactInfoFields, { isInternational: isInternational, isMissingPhoneNumber: isMissingPhoneNumber, isMissingAddressLine1: isMissingAddressLine1 }) })) })) }), _jsxs(Box, { className: clsx(classes.heading, currentStep < step && classes.pending, !isFromTributeUpdate && currentStep > step ? classes.adjustHeadingWithMargin : '', !isFromTributeUpdate && currentStep > step ? classes.headingAndSignUp : ''), children: [_jsx("div", { className: classes.deliveryAddressTitle, children: `${step}. ${isFlyingFlowers ? 'Enter delivery address' : 'Who is this gift for?'} ` }), currentStep === step && !(customer === null || customer === void 0 ? void 0 : customer.id) && (_jsx("div", { children: _jsx(SavedAddressesLogin, { onLoginClick: () => setSignInModal(true), className: classes.adjustSignIn }) }))] }), currentStep === step ? (_jsxs(_Fragment, { children: [(customer === null || customer === void 0 ? void 0 : customer.id) && !(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) && _jsx(SavedAddressesEmpty, {}), (customer === null || customer === void 0 ? void 0 : customer.id) && !!(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) && !isAddNewAddress && (_jsx(ProductPageAddressBook, { savedAddresses: addressAvailable, handleSaveManualAddressCallback: handleSaveManualAddressCallback, newAddressId: newAddressId, addressBookId: addressBookId, setAddressBookId: setAddressBookId, defaultAddress: defaultAddress, isDropship: isDropship, isChangeAddress: isChangeAddress, setIsChangeAddress: setIsChangeAddress, isUpdateRecipient: isUpdateRecipient, isVariantChange: isVariantChange, setIsVariantChange: setIsVariantChange, setHasMissingAddrField: setHasMissingAddrField, isFromBasketUpdate: isFromBasketUpdate, isFromBasket: isFromBasket, onEditClick: onEditClick, hasClickAndCollectDeliveryType: hasClickAndCollectDeliveryType, getAddressLatLongDetails: getAddressLatLongDetails })), (customer === null || customer === void 0 ? void 0 : customer.id) && !!(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) && isAddNewAddress && (_jsxs("div", { className: classes.selectAddressContainer, children: [_jsx(Icon, { icon: "book", className: classes.saveAddressIcon }), _jsx("button", { onClick: handleSelectFromAddressBook, className: classes.selectAddressCaption, children: "Select from address book" })] })), !!(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) && (_jsx("div", { className: classes.horizontalLine, children: _jsx("span", { className: classes.textContent, children: "OR" }) })), (customer === null || customer === void 0 ? void 0 : customer.id) && !isAddNewAddress && !!(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length) && (_jsxs("div", { className: classes.addNewAddressButton, children: [_jsx(RoundButton, { ariaLabel: "Add new recipient", icon: "add", label: "Add new recipient", onClick: handelNewAddress }), !!displayInternationLink && (_jsx("div", { className: classes.internationalDelivery, children: _jsx(Link, { className: classes.internationalDeliveryLink, icon: "", label: "Do you want international delivery?", onClick: () => {
                                        setOpenInternationalModal(true);
                                        locationInternationalDelivery === null || locationInternationalDelivery === void 0 ? void 0 : locationInternationalDelivery('Product page');
                                    } }) }))] })), (!(customer === null || customer === void 0 ? void 0 : customer.id) || ((customer === null || customer === void 0 ? void 0 : customer.id) && isAddNewAddress) || ((customer === null || customer === void 0 ? void 0 : customer.id) && !(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length))) && (_jsxs("div", { className: classes.recipientDetailsContainer, children: [isFlyingFlowers && !showManualAddress && _jsx("p", { className: classes.recipientLabel, children: "Recipient\u2019s details" }), !showManualAddress && (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.input, children: _jsx(TextField, { name: "firstName", label: "Recipient's first name", placeholder: isFuneral || isFromBasket ? "Who's this gift for?" : '', inputProps: { maxLength: 50 }, autoFocus: autoFocus, required: true, fullWidth: true, trimOnBlur: true, hideRequiredOptional: !(isFuneral || isFromBasket) }) }), _jsx("div", { className: clsx(classes.input, isFlyingFlowers && classes.recipientPhoneNumber), children: _jsx(TextField, { name: "lastName", label: "Recipient's last name", placeholder: isFuneral || isFromBasket ? "Who's this gift for?" : '', inputProps: { maxLength: 40 }, required: true, fullWidth: true, trimOnBlur: true, hideRequiredOptional: !(isFuneral || isFromBasket) }) })] })), !isFlyingFlowers && (_jsxs("div", { className: clsx(classes.input, isFlyingFlowers && classes.recipientPhoneNumber), children: [_jsx(TextField, { name: "phone", label: 'Recipient’s contact number', placeholder: isFuneral || isFromBasket ? 'e.g. 01234 567890' : '', required: true, fullWidth: true, trimOnBlur: true, hideRequiredOptional: !(isFuneral || isFromBasket), inputProps: { maxLength: 50 }, onInput: trimPhoneSpace }), _jsx("p", { className: clsx(classes.caption, (customer === null || customer === void 0 ? void 0 : customer.id) && classes.phoneCaption), children: (customer === null || customer === void 0 ? void 0 : customer.id)
                                            ? isInternational
                                                ? 'Our international florists require a valid local telephone number so that they can successfully deliver your order'
                                                : 'We will only use this to contact them when a delivery is attempted.'
                                            : isInternational
                                                ? 'Our international florists require a valid local telephone number so that they can successfully deliver your order'
                                                : 'We will only use this phone number if there is an issue with your delivery' })] })), isFlyingFlowers && !showManualAddress && _jsx("p", { className: classes.recipientLabel, children: "Recipient\u2019s address" }), _jsxs("div", { className: classes.input, children: [_jsx(AddressLookup, { name: "recipientAddress", label: "Search for address", placeholder: addressPlaceholder, addressFields: addressFields, provideManualAddress: true, setManualAddressChosen: setManualAddressChosen, handleAddressFormatCall: handleAddressFormatCall, required: true, fullWidth: true, initialValue: initialRecipientAddress, handleSaveManualAddressCallback: handleSaveManualAddressCallback, countryCode: countryDetails === null || countryDetails === void 0 ? void 0 : countryDetails.codeAlpha3, countryList: [countryDetails], hasVariants: hasVariants, hideRequiredOptional: isFuneral || isFromBasket ? false : true, hasClickAndCollectDeliveryType: hasClickAndCollectDeliveryType, getAddressLatLongDetails: getAddressLatLongDetails }), !!displayInternationLink && !(customer === null || customer === void 0 ? void 0 : customer.id) && (_jsx("div", { className: classes.internationalDelivery, children: _jsx(Link, { className: classes.internationalDeliveryLink, icon: "", label: "Do you want international delivery?", onClick: () => {
                                                setOpenInternationalModal(true);
                                                locationInternationalDelivery === null || locationInternationalDelivery === void 0 ? void 0 : locationInternationalDelivery('Product page');
                                            } }) }))] }), (((customer === null || customer === void 0 ? void 0 : customer.id) && isAddNewAddress) || ((customer === null || customer === void 0 ? void 0 : customer.id) && !(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length))) &&
                                !showManualAddress && (_jsx("div", { className: classes.input, children: _jsx(CheckCircle, { label: _jsx("div", { children: "Save this recipient to address book" }), name: "saveToAddressBook", onClick: () => {
                                        setSaveToAddressBook(!isSaveToAddressBook);
                                    }, type: "checkbox", checked: isSaveToAddressBook, value: isSaveToAddressBook }) }))] })), _jsx("div", { className: classes.next, children: initialRecipientAddress && isUpdateRecipient ? (_jsxs(_Fragment, { children: [_jsx(Button, { className: classes.saveButton, variant: "primary", thin: true, fullWidth: true, title: validDelivery && !isUpdateDate ? 'Save' : 'Next', onClick: () => handleSubmit() }), _jsx(Button, { variant: "tertiary", thin: true, fullWidth: true, title: "Cancel - discard changes", onClick: () => handleCancelChanges() })] })) : isSaveToAddressBook &&
                            (customer === null || customer === void 0 ? void 0 : customer.id) &&
                            (!!isAddNewAddress || !(addressAvailable === null || addressAvailable === void 0 ? void 0 : addressAvailable.length)) &&
                            !showManualAddress ? (_jsx(Button, { variant: "primary", thin: true, fullWidth: true, title: isFlyingFlowers ? 'Next: Delivery date' : 'Next', icon: isFlyingFlowers ? 'shopping_basket' : undefined, onClick: handleSubmit, disabled: disableButton })) : (!showManualAddress && (_jsx(Button, { variant: "primary", thin: true, fullWidth: true, title: isFlyingFlowers ? 'Next: Delivery date' : 'Next', onClick: handleSubmit, icon: isFlyingFlowers ? 'shopping_basket' : undefined, disabled: disableButton }))) })] })) : (stepContentWithEditIcon), _jsx(GiftUnavailableModal, { open: isUnavailableModalOpen, setOpen: setUnavailableModalOpen, changeAddress: () => changeAddress(), closeUnavailableModal: () => {
                    setIsChangeAddress(false);
                }, hideChooseDateOptn: true })] }));
};
export default PurchaseRecipient;
